const actions = {
  SET_STATE: 'admin/SET_STATE',
}

export default actions
